import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Grid, Row, Col, /* Button, */ Alert } from "react-bootstrap";
import { connect } from "react-redux";

import Pager from "../Pager/Pager";
import PageSize from "../Pager/PageSize";
import Table from "../report-table";
import SearchTextBox from "../search-text-box";
import ReportSidebarFilters from "../report-sidebar-filters"
import { reportChangePageAction } from "src/actions";

/* eslint-disable import/no-webpack-loader-syntax */
// import PrintIcon from "-!svg-react-loader!../../images/btn-print.svg";
// import DownloadIcon from "-!svg-react-loader!../../images/download.svg";
import { IRootState } from "src/reducers";
import { ILocalizedError } from 'src/i18n/error-localization';
import Sidebar from '../sidebar';
/* eslint-enable import/no-webpack-loader-syntax */

interface IProps extends RouteComponentProps {
  page: number;
  error: ILocalizedError | null | undefined;
  pageSize: number;
  totalPages: number;
  reportChangePageAction: (page: number,
    pageSize: number,
    history: any) => void;
}

class Report extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      isOpen: false,
      page: 1,
      pageSize: 25,
      totalPages: 1
    };
  }

  public componentDidMount() {
    const params: any = this.props.match.params;

    if (params.page === undefined) {
      this.props.history.push("/report/page/1/pageSize/25");
    } else {
      this.setState({ page: parseInt(params.page || 1, 10), pageSize: parseInt(params.pageSize || 25, 10) });
    }
  }

  public componentDidUpdate(prevProps: IProps) {
    const params: any = this.props.match.params;
    const prevParams: any = prevProps.match.params;

    if (params.page !== prevParams.page || params.pageSize !== prevParams.pageSize) {
      this.props.reportChangePageAction(params.page, params.pageSize, undefined);
    }
  }

  public render() {
    const { page, pageSize, totalPages } = this.props;
    return (
      <Grid fluid={true}>
        {this.props.error &&
          <Row style={{ paddingTop: '10px' }}>
            <Col md={12}>
              <Alert bsStyle="danger" closeLabel='Close'>
                {this.props.error!.defaultMessage}
              </Alert>
            </Col>
          </Row>}
        <Row>
          <Col md={12} className="text-center">
            <SearchTextBox />
          </Col>
        </Row>
        <Row>
          <Col md={3} sm={3} xs={3}>
            <PageSize currentPage={page} pageSize={pageSize} />
          </Col>
          <Col md={6} sm={6} xs={6} className="text-center">
            <Pager totalPages={totalPages} currentPage={page} pageSize={pageSize} />
          </Col>
          <Col md={3} sm={3} xs={3} className="text-right">
            {/* <div style={{ margin: "20px 0px" }}>
              <Button bsStyle="default" className="svg-image-button btn-text-collapsible" title="Print">
                <PrintIcon />
                <span className="title">Print</span>
              </Button>
              <Button bsStyle="default" className="svg-image-button btn-text-collapsible" title="Download">
                <DownloadIcon />
                <span className="title">Download</span>
              </Button>
            </div> */}
          </Col>
        </Row>

        <Table
          page={page}
          pageSize={pageSize}
        />
        <Sidebar>
          <ReportSidebarFilters />
        </Sidebar>
      </Grid>
    );
  }

  protected handleTotalPagesChange = (totalPages: number) => {
    this.setState({ totalPages });
  };
}

const mapStateToProps = (state: IRootState) => ({
  error: state.reports.error,
  page: state.reports.currentPage,
  pageSize: state.reports.pageSize,
  totalPages: state.reports.totalPages,
});

export default connect(
  mapStateToProps,
  { reportChangePageAction }
)(withRouter(Report));



// WEBPACK FOOTER //
// ./src/components/Report/index.tsx